var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-1"},[_vm._t("default",null,{"active":_vm.active,"toggle":_vm.toggle})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }